import script from "./PriorityComp.vue?vue&type=script&setup=true&lang=js"
export * from "./PriorityComp.vue?vue&type=script&setup=true&lang=js"

import "./PriorityComp.vue?vue&type=style&index=0&id=790736ab&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-790736ab"]])

export default __exports__